import React, { useEffect } from "react";
import {
  withRouter,
  RouteComponentProps,
  generatePath,
} from "react-router-dom";
import { Button } from "@material-ui/core";
import AddIcon from "@material-ui/icons/Add";
import { observer } from "mobx-react-lite";

import Container from "components/Layout/Container/Container";
import Header from "components/Layout/Header/Header";
import Page from "components/Layout/Page/Page";
import PublishButton from "components/PublishButton/PublishButton";
import Placeholder from "components/Placeholder/Placeholder";
import withGlobalPopup, {
  GlobalPopupProps,
} from "components/Popup/withGlobalPopup";
import {
  withGlobalSnackbar,
  SnackbarContextProps,
} from "services/snackbar/snackbarContext";
import { PageControl } from "./styles";
import CollectionCard from "./CollectionCard/CollectionCard";
import ROUTES from "navigation/routes";
import CollectionStore from "stores/CollectionStore";
import { SNACKBAR_TYPES } from "components/Snackbar/Snackbar";
interface Props
  extends GlobalPopupProps,
    SnackbarContextProps,
    RouteComponentProps {
  setMessage: (message: string, type?: string) => void;
}

const ContentCollections: React.FC<Props> = ({ history, setMessage }) => {
  const fetchCollections = async () => {
    try {
      await CollectionStore.getAllCollections();
    } catch (error) {
      setMessage(
        error?.message || "Failed to get collections",
        SNACKBAR_TYPES.ERROR,
      );
    }
  };

  useEffect(() => {
    fetchCollections();
  }, [setMessage]);

  const onManageCollection = (initialValues?: any) => {
    const id = initialValues?.id;
    const path = generatePath(ROUTES.CONTENT_ADD_EDIT_COLLECTION, {
      id,
    });

    history.push({ pathname: path, state: { editMode: !!id } });
  };

  const onAddCollection = () => {
    onManageCollection();
  };

  const onEditCollection = (collection: any) => {
    onManageCollection(collection);
  };

  return (
    <Container header={<Header controls={<PublishButton />} />}>
      <Page
        isLoading={CollectionStore.isCollectionsLoading}
        title="Special Programs"
        controls={
          <PageControl>
            <Button
              variant="contained"
              color="primary"
              startIcon={<AddIcon />}
              onClick={onAddCollection}
            >
              Add Special Program
            </Button>
          </PageControl>
        }
      >
        {!CollectionStore.isCollectionsLoading &&
        CollectionStore.collections.length === 0 ? (
          <Placeholder
            height={280}
            width={280}
            text={"No special program added yet."}
          />
        ) : (
          CollectionStore.collections.map(collection => (
            <CollectionCard
              key={collection.id}
              title={collection.name}
              onEdit={() => onEditCollection(collection)}
            />
          ))
        )}
      </Page>
    </Container>
  );
};

export default withGlobalPopup(
  withGlobalSnackbar(withRouter(observer(ContentCollections))),
);
